import React from 'react';
import { useBrand } from 'hooks';

export default Component => props => {
    const [state] = useBrand();
    return <Component {...props} brand={state?.brand} />;
};
